import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private pending = 0;
  private readonly _loading$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loading$.asObservable();

  show() {
    this.pending++;
    if (this.pending === 1) this._loading$.next(true);
  }

  hide() {
    if (this.pending > 0) {
      this.pending--;
      if (this.pending === 0) this._loading$.next(false);
    }
  }

  /** Optional: force reset, useful on global error handlers */
  reset() {
    this.pending = 0;
    this._loading$.next(false);
  }
}
